import { get, put } from "api/axiosApi";
import { env } from "utils/env";
const url = env.REACT_APP_LEASING_API_URL;
const getLeasingExpenses = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/leasingExpenses`);
};

const updateLeasingExpenses = (documentId, siteId, leasingExpenses) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/leasingExpenses`, { documentId, siteId, leasingExpenses });
};
const exp = {
  getLeasingExpenses,
  updateLeasingExpenses
};
export default exp;
